import { useMemo } from 'react';
import { useLocation } from 'react-router-dom';

import { ACTION_OBJECT_TYPES } from 'actions/useActionsLibrary';

import FormHeader from 'components/global/FormHeader';
import { HeaderContainerFormHeader } from 'components/global/styled/FormHeader.styled';
import DynamicList from 'components/list/DynamicList';
import { FilterAction, FilterType } from 'components/list/DynamicListFilterUtils';

import { ADVANCE_WMS_MODULE, ENUMS } from 'services/consts';

import { DYNAMICLISTS } from 'utils/constants';
import PATHS, { mergePaths } from 'utils/paths';

import { faArrowLeft } from '@fortawesome/pro-solid-svg-icons';

export const DailyStaffConfig = {
	id: DYNAMICLISTS.DAILY_STAFF,
	columns: [
		{
			Header: 'warehouseName',
			accessor: 'warehouseName',
			filterType: FilterType.enumMulti,
			enumName: ENUMS.WAREHOUSES,
			width: 90,
			roleName: 'MultiWarehouseModule'
		},
		{
			Header: 'userName',
			accessor: 'userName',
			filterType: FilterType.string,
			width: 30
		},
		{
			Header: 'date',
			accessor: 'date',
			filterType: FilterType.date,
			width: 50,
			filterRemovable: false
		},
		{
			Header: 'firstTransaction',
			accessor: 'firstTransaction',
			filterType: FilterType.string,
			width: 50
		},
		{
			Header: 'lastTransaction',
			accessor: 'lastTransaction',
			filterType: FilterType.string,
			width: 50
		},
		{
			Header: 'totalWorkingHours',
			accessor: 'totalWorkingHours',
			filterType: FilterType.float,
			width: 25
		},
		{
			Header: 'qtyPicked',
			accessor: 'qtyPicked',
			filterType: FilterType.float,
			show: false,
			width: 25
		},
		{
			Header: 'qtySorted',
			accessor: 'qtySorted',
			filterType: FilterType.float,
			show: false,
			width: 25
		},
		{
			Header: 'qtyPacked',
			accessor: 'qtyPacked',
			filterType: FilterType.float,
			show: false,
			width: 25
		},
		{
			Header: 'qtyCounted',
			accessor: 'qtyCounted',
			filterType: FilterType.float,
			show: false,
			width: 25
		},
		{
			Header: 'qtyInbound',
			accessor: 'qtyInbound',
			filterType: FilterType.float,
			show: false,
			width: 25
		},

		{
			Header: 'qtyOutbound',
			accessor: 'qtyOutbound',
			filterType: FilterType.float,
			show: false,
			width: 25
		},
		{
			Header: 'qtyPut',
			accessor: 'qtyPut',
			filterType: FilterType.float,
			show: false,
			width: 25
		},
		{
			Header: 'qtyReturned',
			accessor: 'qtyReturned',
			filterType: FilterType.float,
			show: false,
			width: 25
		},
		{
			Header: 'qtyImported',
			accessor: 'qtyImported',
			filterType: FilterType.float,
			show: false,
			width: 25
		},
		{
			Header: 'ordersPacked',
			accessor: 'ordersPacked',
			filterType: FilterType.float,
			show: false,
			width: 25
		},
		{
			Header: 'ordersReturned',
			accessor: 'ordersReturned',
			filterType: FilterType.float,
			show: false,
			width: 25
		},
		{
			Header: 'wavesCompleted',
			accessor: 'wavesCompleted',
			filterType: FilterType.float,
			show: false,
			width: 25
		},
		{
			Header: 'skusPicked',
			accessor: 'skusPicked',
			filterType: FilterType.float,
			show: false,
			width: 25
		},
		{
			Header: 'skusSorted',
			accessor: 'skusSorted',
			filterType: FilterType.float,
			show: false,
			width: 25
		},
		{
			Header: 'skusPacked',
			accessor: 'skusPacked',
			filterType: FilterType.float,
			show: false,
			width: 25
		},
		{
			Header: 'skusCounted',
			accessor: 'skusCounted',
			filterType: FilterType.float,
			show: false,
			width: 25
		},
		{
			Header: 'skusInbound',
			accessor: 'skusInbound',
			filterType: FilterType.float,
			show: false,
			width: 25
		},
		{
			Header: 'skusOutbound',
			accessor: 'skusOutbound',
			filterType: FilterType.float,
			show: false,
			width: 25
		},
		{
			Header: 'skusPut',
			accessor: 'skusPut',
			filterType: FilterType.float,
			show: false,
			width: 25
		},
		{
			Header: 'skusReturned',
			accessor: 'skusReturned',
			filterType: FilterType.float,
			show: false,
			width: 25
		},
		{
			Header: 'skusImported',
			accessor: 'skusImported',
			filterType: FilterType.float,
			show: false,
			width: 25
		}
	],
	fetchUrl: ADVANCE_WMS_MODULE.GET_DAILY_STAFF_LIST,
	exportName: 'dailyStaff',
	actionObjectType: ACTION_OBJECT_TYPES.WMS
};

const DailyStaff = () => {
	const { state } = useLocation();
	const defaultSort = useMemo(() => [{ id: 'date', desc: true }], []);
	const defaultFilters = useMemo(() => {
		if (!state?.data || Object.keys(state?.data)?.length === 0) {
			return [];
		}

		return [
			{
				column: DailyStaffConfig.columns.find((col) => col.accessor === 'date'),
				action: FilterAction.between,
				value: state.data.date
			}
		];
	}, []);

	return (
		<div>
			<HeaderContainerFormHeader>
				<FormHeader
					lightTitle="reports"
					boldTitle="dailyStaff"
					icon={faArrowLeft}
					backUrl={mergePaths(PATHS.REPORTS, PATHS.OTO_PACK_REPORTS)}
				/>
			</HeaderContainerFormHeader>

			<DynamicList {...DailyStaffConfig} defaultFilters={defaultFilters} defaultSort={defaultSort} />
		</div>
	);
};

export default DailyStaff;
